import { orderTypes } from "./types"

const addItem = item => {
    return {
        type: orderTypes.ADD_ITEM,
        payload: item,
    }
}

const editItem = (index, item) => {
    return {
        type: orderTypes.EDIT_ITEM,
        payload: { index, item },
    }
}

const removeItem = id => {
    return {
        type: orderTypes.REMOVE_ITEM,
        payload: id,
    }
}

const setOrderId = webOrderId => {
    return {
        type: orderTypes.SET_ORDER_ID,
        payload: webOrderId,
    }
}
const setIntegrationId = integrationId => {
    return {
        type: orderTypes.SET_INTEGRATION_ID,
        payload: integrationId,
    }
}

const clear = () => {
    return {
        type: orderTypes.CLEAR,
    }
}

export const orderActions = {
    addItem,
    editItem,
    removeItem,
    setOrderId,
    setIntegrationId,
    clear,
}